module.exports = {
          srcSet: __webpack_public_path__ + "images/1924-91530fc3e967ffe7365753921226cef6-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1924-81283ff621c485674fa3bf6bd0761836-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1924-91530fc3e967ffe7365753921226cef6-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1924-81283ff621c485674fa3bf6bd0761836-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1924-91530fc3e967ffe7365753921226cef6-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1924-91530fc3e967ffe7365753921226cef6-320.jpg"},
          
          width: 320,
          height: 251
        }